export type SettingApplication = "mobile" | "backoffice" | "platform";

export const SETTING_APPLICATIONS: SettingApplication[] = [
  "mobile",
  "backoffice",
  "platform",
];

export type SettingValueType =
  | "string"
  | "number"
  | "boolean"
  | "object"
  | "array";

export const SETTING_VALUE_TYPES: SettingValueType[] = [
  "string",
  "number",
  "boolean",
  "object",
  "array",
];

// Global setting definition. Not account-scoped — editing it affects every
// account, so the catalog screen should be restricted to platform admins.
export interface Setting {
  _id: string;
  id: string;
  product: string;
  application: SettingApplication;
  module: string;
  section: string;
  name: string;
  description: string;
  type: SettingValueType;
  default: unknown;
  active: boolean;
  isDeleted: boolean;
  createdAt: string;
  updatedAt?: string;
}

export type SettingPayload = {
  product: string;
  application: SettingApplication;
  module: string;
  section: string;
  name: string;
  description: string;
  type: SettingValueType;
  default: unknown;
  active: boolean;
  createdBy?: string;
  updatedBy?: string;
};
